import React, { SVGProps } from 'react';

function ChatCheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.33337 8.83335L5.83337 11.3334L12.5 4.66669" stroke="currentColor" strokeWidth="0.833333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default ChatCheckIcon;
